import script from "./xtx-infinite-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-infinite-loading.vue?vue&type=script&setup=true&lang=js"

import "./xtx-infinite-loading.vue?vue&type=style&index=0&id=ebb11c94&lang=less&scoped=true"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebb11c94"]])

export default __exports__